import { configureStore } from "@reduxjs/toolkit";
import AppReducer from "./reducers/AppReducer";

const store = configureStore({
  reducer: {
    app: AppReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Typed hooks usage
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;